export default "__VITE_ASSET__BCQBiaTS__"